import { formatIndiaDate, formatIndiaTime } from './indiaTime';
import { parseVisitDescription } from './patientVisits';

export const ADMIN_STATUS_PILL = {
  submitted: 'pill-blue',
  published: 'pill-orange',
  assigned: 'pill-purple',
  completed: 'pill-green',
  paid: 'pill-green',
  cancelled: 'pill-red',
  expired: 'pill-red',
  accepted: 'pill-blue',
};

const STATUS_LABELS = {
  submitted: 'Submitted',
  published: 'Published',
  assigned: 'Assigned',
  completed: 'Completed',
  paid: 'Paid & Closed',
  cancelled: 'Cancelled',
  expired: 'Expired',
  accepted: 'Accepted',
};

export function getVisitStatusBadgeClass(status) {
  const s = String(status || '').toLowerCase();
  switch (s) {
    case 'submitted':
      return 'badge bg-primary';
    case 'published':
      return 'badge bg-warning text-dark';
    case 'assigned':
      return 'badge bg-info text-dark';
    case 'completed':
    case 'paid':
      return 'badge bg-success';
    case 'cancelled':
    case 'expired':
      return 'badge bg-danger';
    case 'accepted':
      return 'badge bg-primary';
    default:
      return 'badge bg-secondary';
  }
}

export function mapAdminVisitFromApi(item) {
  const statusKey = (item.status || '').trim().toLowerCase();
  const customerRate = item.totalAmount ?? item.totalAMount ?? item.agreedRate ?? 0;
  const isDoctorRateActive = ['published', 'assigned', 'completed', 'paid'].includes(statusKey);
  const doctorRate = isDoctorRateActive ? (item.agreedRate ?? 0) : null;
  const { symptoms, additionalNotes } = parseVisitDescription(item.description || '');

  const formatRate = (value) =>
    Number(value) > 0 ? `₹${Number(value).toLocaleString('en-IN')}` : '—';

  return {
    id: item.idVisitRequest,
    bookingNumber: item.bookingNumber,
    patientId: item.patientID ?? item.patientId,
    patientName: item.patientName || '—',
    patientMobile: item.patientMobile ?? item.PatientMobile ?? '',
    patientEmail: item.patientEmail ?? item.PatientEmail ?? item.emailID ?? item.emailId ?? '',
    patientAddress: item.patientAddress ?? item.PatientAddress ?? '',
    patientLandmark: item.patientLandmark ?? item.PatientLandmark ?? item.landmark ?? '',
    serviceTypeId: item.serviceTypeID ?? item.serviceTypeId,
    serviceTypeName: item.serviceTypeName || '—',
    preferredDate: formatIndiaDate(item.preferredDateTime),
    preferredTime: formatIndiaTime(item.preferredDateTime),
    preferredDateTime: item.preferredDateTime,
    amount: formatRate(customerRate),
    customerRate,
    doctorRate,
    doctorRateLabel: doctorRate != null ? formatRate(doctorRate) : '—',
    agreedRate: item.agreedRate,
    totalAmount: item.totalAmount ?? item.totalAMount,
    status: statusKey,
    statusLabel: STATUS_LABELS[statusKey] || item.status || '—',
    statusPill: ADMIN_STATUS_PILL[statusKey] || 'pill-grey',
    districtName: item.districtName,
    pinCode: item.pINCode ?? item.pinCode,
    assignedDoctorId: item.assignedDoctorID ?? item.assignedDoctorId,
    assignedDoctorName: item.assignedDoctorName,
    description: item.description || '',
    symptoms,
    additionalNotes,
    cancelReason: item.cancelReason || '',
    paymentLabel: item.paymentLabel || 'Unpaid',
    canEdit: item.canEdit === true,
    canPublish: item.canPublish === true,
    canAssign: item.canAssign === true,
    publishedAt: item.publishedAt,
    assignedAt: item.assignedAt,
    createdAt: item.createdAt,
  };
}
